import actionTypes, { REMOVE_IMAGE, RESET_COMPRESSED_IMAGES, RESET_STORE_IMAGES } from './actionTypes';
import { compressImages } from "../operations/utils/imageCompression";
import { pathOr } from 'ramda';

export const compressImagesAction = function(images, imageType) {
  return dispatch => {
    dispatch({ type: actionTypes.IMAGE_COMPRESSION_BEGIN });
    // TODO: check size and compress
    compressImages(images).then((compressedImages) => {
        dispatch({
          type: actionTypes.IMAGE_COMPRESSION_DONE,
          payload :{
            compressedImages
          }
         });
        if (imageType) {
          dispatch({
            type: RESET_STORE_IMAGES,
            imageType: imageType
          })
        }

    }).catch((err) => {
      dispatch({ 
        type: actionTypes.IMAGE_COMPRESSION_FAIL,
        errors: "Image Compression Fails",
      });
    })
  };
};


export const removeImageAction = function(currentIndex) {
  return dispatch => {
    dispatch({
      type: REMOVE_IMAGE,
      payload: {
        currentIndex
      }
    })
  }
}

export const resetCompressedImagesAction = function() {
  return dispatch => {
    dispatch({
      type: RESET_COMPRESSED_IMAGES
    })
  }
}